import React from 'react';
import { Navbar } from '../../components';
import { StandardInterrogationHeader } from '../../containers';

const StandardInterrogation = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <StandardInterrogationHeader />
        </div>
    </div>
  )
}

export default StandardInterrogation